const STATES = {
  FETCHING: 'FETCHING',
  READY: 'READY'
}

export default STATES